import { NgModule } from '@angular/core';
import { AutoresizeDirective } from './autoresize/autoresize';
import { NicknameExistsValidatorDirective } from './nickname-exists-validator/nickname-exists-validator';


@NgModule({
  declarations: [
    AutoresizeDirective,
    NicknameExistsValidatorDirective
  ],
  imports:[

  ],
  exports:[
    AutoresizeDirective,
    NicknameExistsValidatorDirective
  ]
})
export class DirectivesModules{}



// WEBPACK FOOTER //
// ./src/directives/directives.modules.ts